import { Box, FormLabel } from '@mui/material';
import { HelpIconInterface } from '../../utilities/contentful';
import HelpIcon from './HelpIcon';
import Maybe from './Maybe';

export default function FormHelpLabel(props: { helpIcons: HelpIconInterface[], label: string, contentfulId: string, hideHelp?:boolean }) {
  const formLabelStyle = {
    fontSize: '16px',
    fontWeight: 500,
    color: '#444444',
  }

  return (
    <Box display={'flex'} flexDirection={'row'} alignItems={'center'} columnGap={'4px'}>
      <FormLabel sx={formLabelStyle}>{props.label}</FormLabel>
      <Maybe test={!props.hideHelp}>
        <HelpIcon helpIcons={props.helpIcons} contentfulId={props.contentfulId} iconText="" color={'dark'} />
      </Maybe>
    </Box>
  );
}
